export default __webpack_public_path__ + "static/media/ic-fast-simple.ff043cad.svg";